import { render, staticRenderFns } from "./indexOne.vue?vue&type=template&id=c228c78e&scoped=true&"
import script from "./indexOne.vue?vue&type=script&lang=js&"
export * from "./indexOne.vue?vue&type=script&lang=js&"
import style0 from "./indexOne.vue?vue&type=style&index=0&id=c228c78e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c228c78e",
  null
  
)

export default component.exports